import React from "react";
import { Loader2 } from "lucide-react";

interface LoadingStateProps {
  message?: string;
  size?: "sm" | "md" | "lg";
}

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-8 w-8",
  lg: "h-10 w-10",
};

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = "Chargement...",
  size = "md",
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-10">
      {/* Cercle d’aura pulsant */}
      <div className="relative flex items-center justify-center">
        <div className="absolute h-12 w-12 rounded-full bg-primary/10 animate-ping" />
        <div className="absolute h-16 w-16 rounded-full border border-primary/20 animate-[pulse_1.8s_ease_in_out_infinite]" />
        <Loader2
          className={`${sizeClasses[size]} relative text-primary animate-spin`}
        />
      </div>

      {/* Texte */}
      <p className="mt-4 text-sm font-medium text-muted-foreground animate-[fadeIn_0.6s_ease-out]">
        {message}
      </p>
    </div>
  );
};

// Full page loading component
export const PageLoading: React.FC<{ message?: string }> = ({
  message = "Chargement de l'application...",
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <LoadingState message={message} size="lg" />
    </div>
  );
};